import actions from './actions'

/**
 * Metrics slice state. Series are `any[]` because element shape differs per chart:
 * `{ x, y }` for month-level, `[timestamp, value]` for day-level.
 */
export interface MetricsState {
  metricsDcu: any[]
  metricsHau: any[]
  metricsCcu: any[]
  metricsMau: any[]
  metricsMcu: any[]
  metricsPeak: any[]
  metricsVoice: any[]
  metricsVideo: any[]
  metricsRecording: any[]
  /** Operational Data tiles. */
  metricsAUCMinute: string | number
  metricsAUCHour: string | number
  metricsAUCDay: string | number
  metricsAUCMonth: string | number
  metricsAUCPeak: string | number
  metricsAVoMMonth: string | number
  metricsAViMMonth: string | number
  metricsAVoMToday: string | number
  metricsAViMToday: string | number
  metricsAReMToday: string | number
  metricsPlatform: any[]
  metricsPlatformVersion: any[]
  metricsVersionSupport: boolean
  /** False when the plan doesn't include analytics — charts render locked. */
  metricsPlanSupport: boolean
  metricsPlatformVersionData: any[]
  metricsLoading: boolean
  metricsUpdateSuccess: boolean
}

const initialState: MetricsState = {
  metricsDcu: [],
  metricsHau: [],
  metricsCcu: [],
  metricsMau: [],
  metricsMcu: [],
  metricsPeak: [],
  metricsVoice: [],
  metricsVideo: [],
  metricsRecording: [],
  metricsAUCMinute: 0,
  metricsAUCHour: 0,
  metricsAUCDay: 0,
  metricsAUCMonth: 0,
  metricsAUCPeak: 0,
  metricsAVoMMonth: 0,
  metricsAViMMonth: 0,
  metricsAVoMToday: 0,
  metricsAViMToday: 0,
  metricsAReMToday: 0,
  metricsPlatform: [],
  metricsPlatformVersion: [],
  metricsVersionSupport: false,
  metricsPlanSupport: false,
  metricsPlatformVersionData: [],
  metricsLoading: false,
  metricsUpdateSuccess: false,
}

interface SetStateAction {
  type: string
  payload: Partial<MetricsState>
}

export default function metricsReducer(
  state: MetricsState = initialState,
  action: SetStateAction,
): MetricsState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
